import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { useTheme } from '../../../../../theme';
import { BaseButton, BaseButtonProps } from '../../../../../BaseComponents';

interface Props {
	className?: string;
	continueButtonProps?: BaseButtonProps;
	onBack?: () => void;
}

const ExchangeRefundControls: React.FC<Props> = ({ className, continueButtonProps, onBack }) => {
	const { t } = useTranslation('Exchange');
	const { ExchangeRefundControls: theme } = useTheme('Entities').Order;

	return (
		<div className={cn(theme.root, className)}>
			{!!onBack && (
				<BaseButton
					className={cn(theme.button, theme.backButton)}
					variant="secondary"
					onClick={onBack}
					fullWidth
				>
					{t('Controls.Back')}
				</BaseButton>
			)}

			{continueButtonProps && (
				<BaseButton
					variant="action"
					fullWidth
					children={t('Controls.Continue')}
					{...continueButtonProps}
					className={cn(theme.button, theme.continueButton, continueButtonProps.className)}
				/>
			)}
		</div>
	);
};

export default ExchangeRefundControls;
